import { render, staticRenderFns } from "./goodsSpecification.vue?vue&type=template&id=54dfe608&scoped=true"
import script from "./goodsSpecification.vue?vue&type=script&lang=js"
export * from "./goodsSpecification.vue?vue&type=script&lang=js"
import style0 from "./goodsSpecification.vue?vue&type=style&index=0&id=54dfe608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dfe608",
  null
  
)

export default component.exports